import { render, staticRenderFns } from "./PaymentCreditsTab.vue?vue&type=template&id=027a479b&scoped=true"
import script from "./PaymentCreditsTab.vue?vue&type=script&lang=js"
export * from "./PaymentCreditsTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentCreditsTab.vue?vue&type=style&index=0&id=027a479b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a479b",
  null
  
)

export default component.exports